// extracted by mini-css-extract-plugin
export default {"form":"styles_form__U2mmx","container":"styles_container__TGxx7"};